import { Component, OnInit, ViewChild } from '@angular/core';
import { FondeadoresService } from '../../services/fondeadores.service';
import { SucursalesService } from '../../services/sucursales.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { HelpersService } from '../../services/tools/helpers.service';
import {MatDialog, MatPaginator, MatTableDataSource} from '@angular/material';
import { EsquemaInversionModalComponent } from './esquema-inversion-modal/esquema-inversion-modal.component';
import { EliminarFondeadorComponent } from './eliminar-fondeador/eliminar-fondeador.component';
import { Router } from '@angular/router';
declare var $;
@Component({
  selector: 'app-fondeadores',
  templateUrl: './fondeadores.component.html',
  styleUrls: ['./fondeadores.component.scss']
})
export class FondeadoresComponent implements OnInit {
  
  //Variables
  public fondeadores : any[] = [];
  public isUpdate: boolean = false;
  //Paginador
  public mostrarListado:boolean = true;
  public alterTable:any = 'starting';
  errors:any = {};
  searchProcess:any;
  paginate:any = {};
  filterBy:any;
  currentPage = 1;
  lastPage = 1;
  processing:any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;
  searchText:string = "";
  searchSelected: any = {};
  selected:any;

  constructor(
    private fondeadoresService: FondeadoresService,
    private sucursalesService: SucursalesService,
    private helperService: HelpersService,
    private dialog: MatDialog,
    private router : Router
  ) { }

  ngOnInit() {
    this.getFondeadores();
  }

  //Funcion para obtener Fondeadores
  public getFondeadores(page = null){
    let filters = this.getActiveFilters();
    this.searchProcess = this.fondeadoresService.obtenerFondeadores(page, filters)
      .subscribe(response => {
        const content = response.json().content;
        this.fondeadores = content.data;
        console.log("Fondeadores: ", this.fondeadores);
        this.startPaginate(content);
        this.alterTable = (this.fondeadores.length > 0)? false: 'not_result';
      }, error => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  public agregarEsquema(datos: any){
    const dialogRef = this.dialog.open(EsquemaInversionModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {fondeador: datos}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isUpdate = false;
    });
  }

  //Actualizar fondeador
  public actualizarFondeador(id: number){
    this.router.navigate(['/fondeadores/registro-fondeador/',id]);
  }

  //Delete gasto
  public eliminarFondeador(id: number){
    const dialogRef = this.dialog.open(EliminarFondeadorComponent, {
      height: '70vh',
      width: '20vw',
      data: {idFondeador: id }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        window.location.reload();
      }
    });
  }

  public goPerfilFondeador(id: number){
    this.router.navigate(['/fondeadores/perfil-fondeador/',id]);
  }

  private getActiveFilters(){
    let filters:any = {
      page : null,
      search : null,
      paginate : true,
    };

    if(this.page){
      filters.page = this.page;
    }

    if(this.searchText){
      filters.search = this.searchText;
    }

    return filters;
  }
  //Funcion para obtener Fondeadores con paginator
  // public getFondeadores(){
  //   this.fondeadoresService.obtenerFondeadores().subscribe(
  //     (response)=>
  //     {
  //       ELEMENT_DATA.length=0;
  //       //Arreglo con el listado de fondeadores
  //       const jsonResult = response.json();
  //       if(jsonResult.success){
  //         this.fondeadores = jsonResult.content;
  //         console.log("Result json: ", this.fondeadores);
  //         this.fondeadores.forEach(fondeador => {
  //           ELEMENT_DATA.push({ idFondeador: fondeador.id, nombre: fondeador.nombre, email: fondeador.email, telefono:fondeador.telefono, sucursal:fondeador.nombre_suc, tipo_entidad:fondeador.tipo_entidad, rfc:fondeador.rfc, tipo_fondo:fondeador.tipo_fondo, deposito_fondos:fondeador.deposito_fondos })
  //         });
  //       }
  //       console.log("Data: ",ELEMENT_DATA);
  //     }, error =>
  //     {
  //       // se resuelve error 403 y 500
  //       this.helperService.httpGlobalError(error);

  //       if(error.status == 400) {
  //         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
  //       }
  //     }
  //   );
  // }
  
  //Paginador
  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  filtrar(){
    this.goPage(1);
  }

  search(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1 || this.searchSelected.id != ''){
      if(this.searchSelected.id === undefined)
        this.searchSelected.id = '';
      this.searchProcess = this.fondeadoresService.search(this.searchText, page)
          .subscribe(
            response => {
            const content = response.json().content;
            this.fondeadores = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.fondeadores.length > 0)? false: 'not_found';
          }, error => {
            this.processing = false;

            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
              this.setBackendErrors(error.json().content);
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          });
    } else {
      this.getFondeadores();
    }
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.search(page);
    } else {
      this.getFondeadores(page);
    }

  }

  resetSelected(){
    this.selected = undefined;
    this.errors = {};
  }

  startSelected(){
    this.resetSelected();
    this.selected = this.fondeadoresService.getDefaultSchedule();
  }

}
// export interface Datos {
//   //fecha_inversion:string;
//   idFondeador: number;
//   nombre: string;
//   email:string;
//   telefono:string;
//   sucursal:string;
//   tipo_entidad:string;
//   rfc:string;
//   tipo_fondo:string;
//   deposito_fondos:string;
// }
// const ELEMENT_DATA: Datos[] = [];

//Para el paginador esto se coloca después de la definición de la clase
  // displayedColumns = ['idFondeador', 'nombre', 'email', 'telefono', 'sucursal', 'tipo_entidad', 'rfc', 'tipo_fondo','deposito_fondos','acciones'];
  // dataSource = new MatTableDataSource<Datos>(ELEMENT_DATA);
  
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // /**
  //  * Set the paginator after the view init since this component will
  //  * be able to query its view for the initialized paginator.
  //  */
  // ngAfterViewInit() {
  //   setTimeout(() => {this.dataSource.paginator = this.paginator},500);
  //   this.dataSource.paginator = this.paginator;
  //   //Modificar etiquetas del paginador a español
  //   this.paginator._intl.itemsPerPageLabel = 'Registros por página';
  //   this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
  //     if (length === 0 || pageSize === 0) {
  //       return `0 / ${length}`;
  //     }
  //     length = Math.max(length, 0);
  //     const startIndex = page * pageSize;
  //     const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
  //     return `${startIndex + 1} - ${endIndex} de ${length}`;
  //   };
  //   this.paginator._intl.firstPageLabel = 'Primera página';
  //   this.paginator._intl.lastPageLabel = 'Última página';
  //   this.paginator._intl.previousPageLabel = 'Página anterior';
  //   this.paginator._intl.nextPageLabel = 'Página siguiente';
  //   //console.log("Paginator: ", this.paginator);
  // }

  // //Filtro para búsqueda
  // applyFilter(filterValue: string) {
  //   filterValue = filterValue.trim(); // Remove whitespace
  //   filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
  //   this.dataSource.filter = filterValue;
  // }


// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/fondeadores.component.ts